// extracted by mini-css-extract-plugin
module.exports = {"mode":"MoveController_mode__1OiSk","toggle":"MoveController_toggle__36ZI3"};